if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_CI_ENV !== 'true') {
// eslint-disable-next-line no-undef
	__webpack_public_path__ = window.spa_prefix;
}
